// import React, { useEffect } from 'react'
// import Navbar from '../Navbar';
// import {Box, Button, TextField,Grid,Divider, Typography} from '@mui/material';
// import { useState } from 'react';
// import axios from 'axios';
// import swal from 'sweetalert';
// import { Link, useNavigate,useParams } from 'react-router-dom';

// function ViewCustomer() {
//     const navigate = useNavigate();
//     const [loading, setLoading] = useState(true);
//     const [customerInput, setcustomer] = useState([]);

//     const {id} = useParams();
//     useEffect(()=>{
//         const customer_id=id;
//         axios.get(`/api/view-customer/${customer_id}`).then(res=>{
//             if(res.data.status===200){
//                 setcustomer(res.data.customer);
//             }
//             else if(res.data.status === 404){
//                 swal("Error",res.data.message,"error");
//                 navigate('/customermaster');
//             }
//             setLoading(false);
//         });
//     }, [id,navigate]);

//     const handleInput = (e) => {
//         e.persist();
//         setcustomer({...customerInput,[e.target.name]: e.target.value});

//     }
//     if(loading){
//         swal({
//           title: 'Loading',
//           text: 'Please Wait!!!',
//           timer: 1000,
//           buttons: false,
//         }).then(
//           function () {},
//           // handling the promise rejection
//           function (dismiss) {
//             if (dismiss === 'timer') {
//               //console.log('I was closed by the timer')
//             }
//           }
//         )
//       }

//   return (
//     <div>
//     <Navbar />

//     <form id="CATEGORY_FORM">

//     <Box sx={{ border: 3 }} display="flex" flexDirection={"column"} maxWidth={1400} alignItems="center" justifyContent={'center'} margin="auto" marginTop={5} padding={3} borderRadius={5}

//             >
//             <Typography variant="h4" marginBottom="20px" textAlgin="center">Customer Details</Typography>
//             <Divider variant="middle" />
//             <Grid container spacing={5}>
//             <Grid item xs={4}>
//             <TextField InputLabelProps={{ shrink: true }}
//              InputProps={{
//             readOnly: true,
//           }}
//              fullWidth name="name" sx={{ input: { background: 'white' },cursor: 'pointer' }}  onChange={handleInput}  value={customerInput.name} id="filled-read-only-input" margin='normal' label="Name" variant="filled"/>
//             </Grid>
//             <Grid item xs={4}>
//             <TextField
//             InputProps={{
//             readOnly: true,
//           }}
//             InputLabelProps={{ shrink: true }} fullWidth name="gstno" sx={{ input: { background: 'white' } }} onChange={handleInput} value={customerInput.gstno} id="filled-basic" margin='normal' label="GST NO" variant="filled" />
//             </Grid>
//             <Grid item xs={4}>
//             <TextField
//             InputProps={{
//             readOnly: true,
//           }}
//              InputLabelProps={{ shrink: true }} fullWidth name="pcode" sx={{ input: { background: 'white' } }} onChange={handleInput} value={customerInput.pcode} id="filled-basic" margin='normal' label="Party Code" variant="filled" />
//             </Grid>
//              </Grid>

//              <Grid container spacing={5}>
//             <Grid item xs={4}>
//             <TextField
//             InputProps={{
//             readOnly: true,
//           }}
//              InputLabelProps={{ shrink: true }} fullWidth name="acode"  sx={{ input: { background: 'white' } }} onChange={handleInput} value={customerInput.acode} id="filled-basic" margin='normal' label="Associate Code" variant="filled" />
//             </Grid>
//             <Grid item xs={4}>
//             <TextField
//             InputProps={{
//             readOnly: true,
//           }}
//              InputLabelProps={{ shrink: true }} fullWidth name="maddress" sx={{ input: { background: 'white' } }} onChange={handleInput} value={customerInput.maddress} id="filled-basic" margin='normal' label="Mini Address" variant="filled" />
//             </Grid>
//             <Grid item xs={4}>
//             <TextField
//             InputProps={{
//             readOnly: true,
//           }}
//              InputLabelProps={{ shrink: true }} fullWidth name="email" sx={{ input: { background: 'white' } }} onChange={handleInput} value={customerInput.email} id="filled-basic" margin='normal' label="Email" variant="filled"/>
//             </Grid>
//             </Grid>
//             {/* <Grid container spacing={5}>

//             <Grid item xs={6}> */}
//             <TextField
//             InputProps={{
//             readOnly: true,
//           }}
//              InputLabelProps={{ shrink: true }} fullWidth name="address" sx={{ input: { background: 'white' } }} onChange={handleInput} value={customerInput.address} id="filled-basic" margin='normal' label="Address" variant="filled" />
//             <Grid container spacing={5}>
//             <Grid item xs={6}>
//             <TextField  InputProps={{
//             readOnly: true,
//           }}
//              InputLabelProps={{ shrink: true }} fullWidth name="cname" onChange={handleInput} value={customerInput.cname} sx={{ input: { background: 'white' } }} id="filled-basic" margin='normal' label="Party Contact Person" variant="filled" />
//             </Grid>
//             <Grid item xs={6}>
//             <TextField  InputProps={{
//             readOnly: true,
//           }}
//              InputLabelProps={{ shrink: true }} fullWidth name="cnamecontact" onChange={handleInput} value={customerInput.cnamecontact} sx={{ input: { background: 'white' } }} id="filled-basic" margin='normal' label="Contact Number" variant="filled" />
//             </Grid>
//             </Grid>
//             <Box marginTop={5} padding={3} borderRadius={5}>
//             <Button
//             style={{
//           maxWidth: "200px",
//           maxHeight: "100px",
//           minWidth: "50px",
//           minHeight: "30px"
//         }}
//              type="submit" component={Link} to={`/customermaster`} variant="contained">Back</Button>
//             </Box>

//             </Box>
//     </form>
//     </div>
//   )
// }

// export default ViewCustomer

import React, { useEffect } from "react";
import Navbar from "../Navbar";
import {
  Box,
  Button,
  TextField,
  Grid,
  Divider,
  Typography,
} from "@mui/material";
import { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";

function ViewCustomer() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [customerInput, setcustomer] = useState([]);

  const { id } = useParams();
  useEffect(() => {
    const customer_id = id;
    axios.get(`/api/view-customer/${customer_id}`).then((res) => {
      if (res.data.status === 200) {
        setcustomer(res.data.customer);
      } else if (res.data.status === 404) {
        swal("Error", res.data.message, "error");
        navigate("/certificates/customermaster");
      }
      setLoading(false);
    });
  }, [id, navigate]);

  const handleInput = (e) => {
    e.persist();
    setcustomer({ ...customerInput, [e.target.name]: e.target.value });
  };
  if (loading) {
    swal({
      title: "Loading",
      text: "Please Wait!!!",
      timer: 1000,
      buttons: false,
    }).then(
      function () {},
      // handling the promise rejection
      function (dismiss) {
        if (dismiss === "timer") {
          //console.log('I was closed by the timer')
        }
      }
    );
  }
  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  return (
    <div>
      <Navbar />

      <form id="CATEGORY_FORM">
        <div className="card px-8 m-5">
          <div className="card-header">
            <div class="d-flex justify-content-between">
              <h4>Customer Details</h4>
              <ThemeProvider theme={theme}>
                <Button
                  component={Link}
                  to="/certificates/customermaster"
                  variant="contained"
                  color="apple"
                >
                  back
                </Button>
              </ThemeProvider>
            </div>
          </div>
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th>Party Name</th>
                <td onChange={handleInput}>{customerInput.name}</td>
                <th>GST NO</th>
                <td onChange={handleInput}>{customerInput.gstno}</td>
              </tr>
              <tr>
                <th>Party Code</th>
                <td onChange={handleInput}>{customerInput.pcode}</td>
                <th>Associate Code</th>
                <td onChange={handleInput}>{customerInput.acode}</td>
              </tr>
              <tr>
                <th>Mini address</th>
                <td onChange={handleInput}>{customerInput.maddress}</td>
                <th>Email</th>
                <td onChange={handleInput}>{customerInput.email}</td>
              </tr>
              <tr>
                <th>Party Contact Person</th>
                <td onChange={handleInput}>{customerInput.cname}</td>
                <th>Contact NO</th>
                <td onChange={handleInput}>{customerInput.cnamecontact}</td>
              </tr>
              <tr>
                <th>Address</th>
                <td onChange={handleInput}>{customerInput.address}</td>
                <th>Created By</th>
                <td onChange={handleInput}>{customerInput.created_by}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </form>
    </div>
  );
}

export default ViewCustomer;
